import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axios';

/**
 * Plan slice for fetching and managing subscription plans.
 */

export const fetchPlans = createAsyncThunk(
  'plans/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/plans');
      return response.data.plans;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to load plans');
    }
  }
);

export const createCheckout = createAsyncThunk(
  'plans/checkout',
  async (planId, { rejectWithValue }) => {
    try {
      const response = await api.post('/v1/subscription/checkout', {
        plan_id: planId,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Checkout failed');
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: null,
  checkoutLoading: false,
};

const planSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCheckout.pending, (state) => {
        state.checkoutLoading = true;
      })
      .addCase(createCheckout.fulfilled, (state) => {
        state.checkoutLoading = false;
      })
      .addCase(createCheckout.rejected, (state) => {
        state.checkoutLoading = false;
      });
  },
});

export default planSlice.reducer;
